import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "bubble-button__bubble" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "58",
    height: "59",
    viewbox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.0834 29.5L45.9167 29.5",
      stroke: "#1C212D",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M29.0001 12.5834L45.9167 29.5L29.0001 46.4167",
      stroke: "#1C212D",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)

import useContext from '@/composables/useContext';


const __default__ = {
  name: 'BubbleButtonComponent'
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  to: {
    type: String,
    required: true,
  },
  style: {
    type: String,
  },
  label: {
    type: String,
  }
},
  setup(__props) {

const props = __props





return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: __props.to,
    class: _normalizeClass(`bubble-button bubble-button--${__props.style}`)
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.label) + " ", 1),
      _hoisted_1
    ]),
    _: 1
  }, 8, ["to", "class"]))
}
}

})